import { render } from "./DeleteFormModal.vue?vue&type=template&id=03c7eb9a&scoped=true"
import script from "./DeleteFormModal.vue?vue&type=script&lang=js"
export * from "./DeleteFormModal.vue?vue&type=script&lang=js"

import "./DeleteFormModal.vue?vue&type=style&index=0&id=03c7eb9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03c7eb9a"]])

export default __exports__